/* tslint:disable */
import {
  Department,
  Group
} from '../index';

declare var Object: any;
export interface ProblemTaskReasonCodeInterface {
  "sfdcId"?: string;
  "CreatedById"?: string;
  "CurrencyIsoCode"?: string;
  "LastModifiedById"?: string;
  "OwnerId"?: string;
  "Name"?: string;
  "PgMO_Departments__c"?: string;
  "PgMO_Departments_Name__c"?: string;
  "PgMO_Groups__c"?: string;
  "PgMO_Group_Name__c"?: string;
  "PgMO_Tasks__c"?: string;
  "Reason_Category__c"?: string;
  "Reason_Description__c"?: string;
  "Reason_Sub_Category__c"?: string;
  "CreatedDate"?: Date;
  "IsDeleted"?: boolean;
  "LastModifiedDate"?: Date;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
  department?: Department;
  group?: Group;
  task?: Group;
}

export class ProblemTaskReasonCode implements ProblemTaskReasonCodeInterface {
  "sfdcId": string;
  "CreatedById": string;
  "CurrencyIsoCode": string;
  "LastModifiedById": string;
  "OwnerId": string;
  "Name": string;
  "PgMO_Departments__c": string;
  "PgMO_Departments_Name__c": string;
  "PgMO_Groups__c": string;
  "PgMO_Group_Name__c": string;
  "PgMO_Tasks__c": string;
  "Reason_Category__c": string;
  "Reason_Description__c": string;
  "Reason_Sub_Category__c": string;
  "CreatedDate": Date;
  "IsDeleted": boolean;
  "LastModifiedDate": Date;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  department: Department;
  group: Group;
  task: Group;
  constructor(data?: ProblemTaskReasonCodeInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ProblemTaskReasonCode`.
   */
  public static getModelName() {
    return "ProblemTaskReasonCode";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ProblemTaskReasonCode for dynamic purposes.
  **/
  public static factory(data: ProblemTaskReasonCodeInterface): ProblemTaskReasonCode{
    return new ProblemTaskReasonCode(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ProblemTaskReasonCode',
      plural: 'ProblemTaskReasonCodes',
      path: 'ProblemTaskReasonCodes',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "OwnerId": {
          name: 'OwnerId',
          type: 'string'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "PgMO_Departments__c": {
          name: 'PgMO_Departments__c',
          type: 'string'
        },
        "PgMO_Departments_Name__c": {
          name: 'PgMO_Departments_Name__c',
          type: 'string'
        },
        "PgMO_Groups__c": {
          name: 'PgMO_Groups__c',
          type: 'string'
        },
        "PgMO_Group_Name__c": {
          name: 'PgMO_Group_Name__c',
          type: 'string'
        },
        "PgMO_Tasks__c": {
          name: 'PgMO_Tasks__c',
          type: 'string'
        },
        "Reason_Category__c": {
          name: 'Reason_Category__c',
          type: 'string'
        },
        "Reason_Description__c": {
          name: 'Reason_Description__c',
          type: 'string'
        },
        "Reason_Sub_Category__c": {
          name: 'Reason_Sub_Category__c',
          type: 'string'
        },
        "CreatedDate": {
          name: 'CreatedDate',
          type: 'Date'
        },
        "IsDeleted": {
          name: 'IsDeleted',
          type: 'boolean'
        },
        "LastModifiedDate": {
          name: 'LastModifiedDate',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        department: {
          name: 'department',
          type: 'Department',
          model: 'Department',
          relationType: 'belongsTo',
                  keyFrom: 'PgMO_Departments__c',
          keyTo: 'sfdcId'
        },
        group: {
          name: 'group',
          type: 'Group',
          model: 'Group',
          relationType: 'belongsTo',
                  keyFrom: 'PgMO_Groups__c',
          keyTo: 'sfdcId'
        },
        task: {
          name: 'task',
          type: 'Group',
          model: 'Group',
          relationType: 'belongsTo',
                  keyFrom: 'PgMO_Tasks__c',
          keyTo: 'sfdcId'
        },
      }
    }
  }
}
